var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import { CheckList } from 'src/ui/components/Input/CheckList/CheckList';
import { SeeMoreLess } from 'src/ui/components/SeeMoreLess/SeeMoreLess';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './InvalidDocumentItem.module.scss';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
var InvalidDocumentHeader = function (props) {
    var _a;
    var i18n = props.i18n, label = props.label, isContentOpen = props.isContentOpen, hasReasons = props.hasReasons;
    var seeMoreLessLabel = getPropsByKeyPath(i18n, "keyValueMap.common.".concat(isContentOpen ? 'seeLess' : 'seeMore'));
    var iconClass = classNames(styles.dropdownIcon, (_a = {}, _a[styles.dropdownIconActive] = isContentOpen, _a));
    return (_jsxs("div", __assign({ className: styles.dropdownHeaderWrapper }, { children: [_jsx("span", __assign({ className: styles.invalidDocumentLabel }, { children: label })), hasReasons && (_jsxs("div", __assign({ className: styles.dropdownLabelWrapper }, { children: [_jsx("span", __assign({ className: styles.dropdownLabel }, { children: seeMoreLessLabel })), _jsx(Icons, { className: iconClass, icon: isContentOpen ? E_ICONS.SUB : E_ICONS.ADD })] })))] })));
};
var DEFAULT_DROP_DOWN_OPEN = true;
export var InvalidDocumentItem = function (props) {
    var i18n = props.i18n, doc = props.doc, currentReasons = props.currentReasons, onReasonsChange = props.onReasonsChange;
    var label = doc.label, reasons = doc.reasons;
    var _a = useState(DEFAULT_DROP_DOWN_OPEN), isContentOpen = _a[0], setIsContentOpen = _a[1];
    var hasReasons = reasons.length > 0;
    var handleDropDownHeaderClick = function () {
        setIsContentOpen(function (prev) { return !prev; });
    };
    var headerChildren = (_jsx(InvalidDocumentHeader, { i18n: i18n, label: label, isContentOpen: isContentOpen, hasReasons: hasReasons }));
    return (_jsxs("div", __assign({ className: styles.invalidDocumentItem }, { children: [_jsx(SeeMoreLess, __assign({ headerChildren: headerChildren, defaultOpen: DEFAULT_DROP_DOWN_OPEN, onHeaderClick: handleDropDownHeaderClick }, { children: hasReasons && (_jsx(CheckList, { i18n: i18n, options: reasons, currentOption: currentReasons, onChange: onReasonsChange, className: styles.invalidDocumentChecklist })) })), !isContentOpen && currentReasons.length > 0 && (_jsx("ul", __assign({ className: styles.reasonsResumeWrapper }, { children: currentReasons.map(function (reason) { return (_jsx("li", __assign({ className: styles.reasonsResumeItem }, { children: reason }))); }) })))] })));
};
